import React from 'react';

import Colors from 'common/colors/constants';
import Pill, { type PillStyle } from 'common/common/Pill';
import isNil from 'common/util/isNil';

import type VoteWeight from 'common/constants/voteWeight';

type Pill = {
  name: string;
  pillStyle: PillStyle;
};

const WeightMap: Record<VoteWeight, Pill> = {
  0: {
    name: 'Nice to have',
    pillStyle: {
      color: Colors.blue90,
      background: Colors.blue30,
    },
  },
  10: {
    name: 'Important',
    pillStyle: {
      background: Colors.purple30,
      color: Colors.purple90,
    },
  },
  20: {
    name: 'Must have',
    pillStyle: {
      background: Colors.orange30,
      color: Colors.orange90,
    },
  },
} as const;

type Props = {
  weight?: VoteWeight;
};

const VoteWeightPill = ({ weight }: Props) => {
  if (isNil(weight) || !(weight in WeightMap)) {
    return null;
  }

  const weightToRender = WeightMap[weight];
  return (
    <div className="voteWeightPill">
      <Pill pillStyle={weightToRender.pillStyle}>{weightToRender.name}</Pill>
    </div>
  );
};

export default VoteWeightPill;
